import { Injectable } from '@angular/core';
import { AuthUser } from '../auth.interfaces';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GhostingService {
  private asUserSubject = new BehaviorSubject(
    (JSON.parse(localStorage.getItem('asUser') ?? '{}').user ??
      null) as AuthUser | null,
  );
  asUser$ = this.asUserSubject.asObservable();
  private inProgressSubject = new BehaviorSubject(false);
  inProgress$ = this.inProgressSubject.asObservable();

  setAsUser(user: AuthUser) {
    localStorage.setItem(
      'asUser',
      JSON.stringify({
        user: {
          id: user.id,
          firstName: user.firstName,
          lastName: user.lastName,
        },
      }),
    );
    this.inProgressSubject.next(true);
    window.location.href = environment.frontendUri;
  }

  clearAsUser() {
    localStorage.removeItem('asUser');
    this.inProgressSubject.next(true);
    window.location.href = environment.frontendUri;
  }

  getAsUser() {
    return this.asUserSubject.getValue();
  }
}
